
import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware';

export interface UserType {
   firstname: string
   token: string
   role: string
   role2: string
   role_other: string
   group_id: number
}

interface UserAction {
   updateFirstname: (value: UserType['firstname']) => void
   updateToken: (value: UserType['token']) => void
   updateRole: (value: UserType['role']) => void
   updateRole2: (value: UserType['role2']) => void
   updateRoleOther: (value: UserType['role_other']) => void
   updateGroupId: (value: UserType['group_id']) => void
   removeUser: () => void
};


export const useUserStore = create<UserType & UserAction>()(
   persist(
      (set) => ({
         firstname: '',
         token: '',
         role: 'unknown',
         role2: '',
         role_other: '',
         group_id: globalThis.group_id ? globalThis.group_id : 0,
      
         updateFirstname: (value: UserType['firstname']) => set((state: UserType) => ({ ...state, firstname: value })),
         updateToken: (value: UserType['token']) => set((state: UserType) => ({ ...state, token: value })),
         updateRole: (value: UserType['role']) => set((state: UserType) => ({ ...state, role: value })),
         updateRole2: (value: UserType['role2']) => set((state: UserType) => ({ ...state, role2: value })),
         updateRoleOther: (value: UserType['role_other']) => set((state: UserType) => ({ ...state, role_other: value })),
         updateGroupId: (value: UserType['group_id']) => set((state: UserType) => ({ ...state, group_id: value })),
         removeUser: ()=> set((state: UserType)=> ({...state, firstname:'', token:'',role:'unknown', group_id: globalThis.group_id ? globalThis.group_id : 0}))
   }),
   {
      name: 'user',
      storage: createJSONStorage(() => sessionStorage), // (optional) by default, 'localStorage' is used
   }
));
